import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { Table, Typography } from "antd"

import { Value } from "@components/Text"

const { Text } = Typography
const { Row, Cell } = Table.Summary

const BeneficiariesTableSummary = ({ amountByKey, selectedRowKeys }) => {
  const totalAmount = useMemo(() =>
    selectedRowKeys
      .map(key => amountByKey[key])
      .reduce((sum, value) => sum + (Number(value) || 0), 0)
  , [ amountByKey, selectedRowKeys ])

  return (
    <Table.Summary>
      <Row>
        <Cell
          index={0}
          align="right"
          colSpan={5}
        >
          <Text strong>Total Amount:</Text>
        </Cell>

        <Cell
          index={5}
          align="left"
        >
          <Value value={totalAmount} />
        </Cell>

        <Cell index={6} />
      </Row>
    </Table.Summary>
  )
}

BeneficiariesTableSummary.propTypes = {
  amountByKey: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ])).isRequired,
  selectedRowKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default BeneficiariesTableSummary
